export interface GetNextRangeSelectionParams {
  orderedIds: string[];
  selectedIds: string[];
  anchorId: string | null;
  targetId: string;
  targetChecked: boolean;
  isRangeSelection: boolean;
}

export const getNextRangeSelection = ({
  orderedIds,
  selectedIds,
  anchorId,
  targetId,
  targetChecked,
  isRangeSelection,
}: GetNextRangeSelectionParams): string[] => {
  const selected = new Set(selectedIds);
  const targetIndex = orderedIds.indexOf(targetId);
  const anchorIndex = anchorId ? orderedIds.indexOf(anchorId) : -1;
  const shouldApplyRange = isRangeSelection && anchorIndex !== -1 && targetIndex !== -1;
  const idsToUpdate = shouldApplyRange
    ? orderedIds.slice(Math.min(anchorIndex, targetIndex), Math.max(anchorIndex, targetIndex) + 1)
    : [targetId];

  for (const id of idsToUpdate) {
    if (targetChecked) {
      selected.add(id);
    } else {
      selected.delete(id);
    }
  }

  const orderedIdSet = new Set(orderedIds);
  const visibleSelection = orderedIds.filter(id => selected.has(id));
  const nonVisibleSelection = selectedIds.filter(id => !orderedIdSet.has(id) && selected.has(id));

  return [...visibleSelection, ...nonVisibleSelection];
};
